import styled from 'styled-components';

export const DaySpan = styled('span')`
	text-transform: capitalize;
`;
